<modal-overlay>
  <modal-box>
    <div class="file-upload-comment-modal">
      <div class="file-upload-comment-content">
        <h5 class="file-upload-comment-title text-center mb-2">
          {{ modalTitle | translate }}
        </h5>
        <textarea
          class="file-upload-comment-textarea"
          [formControl]="message"
          [placeholder]="
            'COURSES.COURSE.EXERCISE.FLAGGED_EXERCISE_MODAL.PLACEHOLDER'
              | translate
          "
        ></textarea>
        <div
          *ngIf="message.invalid && (message.dirty || message.touched)"
          class="d-flex flex-column mini-label color-hinvalid validation-text font-weight-bold pt-1"
        >
          <span *ngIf="message.errors?.required">
            {{
              "COURSES.COURSE.EXERCISE.FLAGGED_EXERCISE_MODAL.VALIDATE_MESSAGE_REQUIRED"
                | translate
                | uppercase
            }}
          </span>
          <span *ngIf="message.errors?.maxlength">
            {{
              "COURSES.COURSE.EXERCISE.FLAGGED_EXERCISE_MODAL.VALIDATE_MESSAGE_MAXLENGTH"
                | translate
                  : { maxLength: message.errors?.maxlength?.requiredLength }
                | uppercase
            }}
          </span>
        </div>

        <div
          *ngIf="!data.isTeacher; else teacherContainer"
          class="d-flex justify-content-center w-100 mt-3"
        >
          <button
            type="button"
            class="btn-primary-900 btn-lg w-50"
            (click)="cancel()"
          >
            {{ "GLOBAL.CANCEL_BUTTON" | translate }}
          </button>
        </div>

        <ng-template #teacherContainer>
          <div class="file-upload-comment-buttons mt-3">
            <button
              type="button"
              class="btn-blue-light-600 btn-lg w-50"
              (click)="cancel()"
            >
              {{ "TUTORIAL_MODAL.SKIP" | translate }}
            </button>

            <button
              type="button"
              [disabled]="message.invalid"
              class="btn-primary-900 btn-lg w-50"
              (click)="confirm()"
            >
              {{ "GLOBAL.CONFIRM" | translate }}
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </modal-box>
</modal-overlay>
